<template>
  <div>
    <h5>Scegli i laboratori da seguire:</h5>
    <p class="dea-heading--medium__s">
      La partecipazione ai laboratori non è vincolante, potrebbe tuttavia essere necessaria al raggiungimento del monte
      ore necessario per l'attestato di partecipazione su S.O.F.I.A.
    </p>

    <form action="" method="POST" class="lab-sessions">
      <Checkbox
        id="no-lab-checkbox"
        type="checkbox"
        name="no-lab-checkbox"
        :checked="voidLabsChecked"
        @change="selectVoidLabs($event)"
        >Parteciperò unicamente alla plenaria</Checkbox
      >
      <div class="lab-sessions__container">
        <LabsSession
          v-for="(session, index) in sessions()"
          :key="session.id"
          :session="session"
          :select-lab-action="selectLabAction"
          :default-open="firstEmptySession === session.id"
          :previous-slot="sessions()[index - 1] && sessions()[index - 1].slot_name"
        >
        </LabsSession>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Checkbox from "@/components/elements/Checkbox";
import LabsSession from "~/components/events/components/LabsSession";

export default {
  name: "LabsChoice",
  components: {
    Checkbox,
    LabsSession,
  },
  props: {
    selectLabAction: {
      type: Function,
      default: () => {},
    },
    firstEmptySession: {
      type: Number,
      default: 0,
    },
    sessions: {
      type: Function,
      default: () => {
        return [];
      },
    },
    hasHeaderMargin: {
      type: Boolean,
      defaule: false,
    },
  },
  computed: {
    ...mapGetters(["voidLabsChecked", "selectedLabs"]),
  },
  methods: {
    selectVoidLabs(event) {
      this.$store.dispatch("setEmptyLabs", event.target.checked);
      this.$store.commit("setVoidLabsChecked", event.target.checked);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.lab-sessions {
  position: relative;

  &__container {
    & > div:not(:first-child) {
      margin-top: $space-base;

      .lab-session__slot-name {
        margin-top: $space-x-large;
      }
    }
  }
}
</style>
